import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import MatrixCell from './MatrixCell';

const SortableOptionRow = ({
  setting,
  gridTemplateColumns,
  draft,
  venueOwnerships,
  onRename,
  onRequestRemove,
  onCycleCell,
  isPendingRemoval,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: setting.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    gridTemplateColumns,
    background: isDragging ? 'var(--sl-bg-secondary-hover)' : undefined,
    opacity: isDragging ? 0.85 : 1,
    position: 'relative',
    zIndex: isDragging ? 5 : undefined,
  };

  return (
    <div ref={setNodeRef} className="ar-matrix__row" style={style} {...attributes}>
      <div className="ar-matrix__option-cell">
        <span
          className="ar-matrix__drag-handle"
          {...listeners}
          aria-label="Drag to reorder"
          title="Drag to reorder"
        >
          <i className="fas fa-grip-vertical" />
        </span>
        <input
          type="text"
          className="ar-matrix__option-name"
          defaultValue={setting.name}
          onBlur={(e) => {
            if (isPendingRemoval) return;
            onRename(setting.id, e.target.value);
          }}
        />
        <button
          type="button"
          className="ar-matrix__option-remove"
          onClick={() => onRequestRemove(setting.id)}
          title="Remove option"
        >
          <i className="far fa-trash-alt" />
        </button>
      </div>
      {venueOwnerships.map((vo) => {
        const cfg = draft[vo.id] || { enabled: new Set(), defaultId: null };
        return (
          <MatrixCell
            key={vo.id}
            venueOwnership={vo}
            settingId={setting.id}
            isEnabled={cfg.enabled.has(setting.id)}
            isDefault={cfg.defaultId === setting.id}
            onCycleCell={onCycleCell}
          />
        );
      })}
    </div>
  );
};

SortableOptionRow.propTypes = {
  setting: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  gridTemplateColumns: PropTypes.string.isRequired,
  draft: PropTypes.object.isRequired,
  venueOwnerships: PropTypes.array.isRequired,
  onRename: PropTypes.func.isRequired,
  onRequestRemove: PropTypes.func.isRequired,
  onCycleCell: PropTypes.func.isRequired,
  isPendingRemoval: PropTypes.bool,
};

SortableOptionRow.defaultProps = {
  isPendingRemoval: false,
};

export default SortableOptionRow;
